var defaultLocale = 'en-us';
var defaultLocaleFile = './core/i18n/angular-locale_en-us';
var requireContext = require.context('./core/i18n');

function getBrowserLocale() {
    return (navigator.language || navigator.userLanguage || defaultLocale).toLowerCase();
}

function findBrowserLocaleFile(locale) {
    var matchingLocales = requireContext.keys().filter(function (l) { return l.indexOf(locale) > 0; });

    return matchingLocales && matchingLocales.length > 0
        ? matchingLocales[0]
        : defaultLocaleFile;
}


var browserLocale = getBrowserLocale();
var localeFile = findBrowserLocaleFile(browserLocale);
requireContext(localeFile);


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/localization.js
 ** module id = 193
 ** module chunks = 0
 **/